import { useMemo } from "react";
import { motion } from "framer-motion";
import { useProducts, discountPct } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { useI18n } from "@/lib/i18n";
import { ProductGrid } from "@/components/shop/ProductCard";
import { SplitText, Reveal } from "@/components/fx/Motion";

export default function Sale() {
  const { t } = useI18n();
  const { data = [], isLoading } = useProducts({ sort: "discount" });
  useSeo(t("nav_sale"));
  const items = useMemo(() => data.filter((p) => discountPct(p) > 0), [data]);
  const best = items.length ? discountPct(items[0]) : 0;

  return (
    <div data-testid="sale-page" className="max-w-7xl mx-auto px-5 lg:px-10 py-14 lg:py-20">
      <p className="eyebrow mb-4">{t("sale_eyebrow")}</p>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 border-b border-white/10 pb-10">
        <div>
          <h1 data-testid="sale-title" className="font-display text-5xl sm:text-6xl lg:text-8xl"><SplitText text={t("sale_title")} /></h1>
          <Reveal delay={0.2}><p className="text-white/60 mt-4 max-w-md">{t("sale_text")}</p></Reveal>
        </div>
        {best > 0 && (
          <motion.div data-testid="sale-best-badge" initial={{ scale: 0, rotate: -20 }} animate={{ scale: 1, rotate: -6 }} transition={{ type: "spring", stiffness: 140, delay: 0.4 }}
            className="h-36 w-36 rounded-full bg-gold text-[#0b0a08] flex items-center justify-center text-center font-display text-xl leading-tight p-4 shrink-0">
            {t("sale_total_savings", { pct: best })}
          </motion.div>
        )}
      </div>
      {!isLoading && !items.length ? <p data-testid="sale-empty" className="text-white/60">{t("sale_empty")}</p> : <ProductGrid products={items} loading={isLoading} testid="sale-grid" />}
    </div>
  );
}
